var _path, _path2, _rect, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 116,
    viewBox: "0 0 90 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 0H64.8091L89.9999 25.1181V116H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M90.0004 25.1181L64.8096 0V25.1181H90.0004Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    y: 80.6064,
    width: 89.9999,
    height: 35.3937,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4749 107.78C26.3829 107.78 26.3369 107.735 26.3369 107.644L26.3645 104.676L33.1237 91.9315H26.7232C26.6496 91.9315 26.6128 91.8952 26.6128 91.8226V88.9633C26.6128 88.8725 26.6496 88.8271 26.7232 88.8271H36.7103C36.8022 88.8271 36.8482 88.8725 36.8482 88.9633V91.9042L30.1166 104.594H36.7655C36.839 104.594 36.8758 104.639 36.8758 104.73L36.9034 107.644C36.9034 107.735 36.8574 107.78 36.7655 107.78H26.4749Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9195 107.78C42.8275 107.78 42.7815 107.735 42.7815 107.644L42.8091 88.9361C42.8091 88.8635 42.8459 88.8271 42.9195 88.8271H46.0094C46.083 88.8271 46.1198 88.8635 46.1198 88.9361L46.1474 107.644C46.1474 107.735 46.1106 107.78 46.037 107.78H42.9195Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8503 107.78C52.7584 107.78 52.7124 107.735 52.7124 107.644L52.7676 88.9361C52.7676 88.8635 52.8044 88.8271 52.8779 88.8271H58.175C59.8671 88.8271 61.2005 89.3355 62.1753 90.3521C63.1685 91.3687 63.6651 92.7484 63.6651 94.4912C63.6651 95.7801 63.4076 96.8966 62.8926 97.8406C62.3776 98.7846 61.7063 99.5108 60.8787 100.019C60.051 100.527 59.1498 100.782 58.175 100.782H56.0782V107.644C56.0782 107.735 56.0322 107.78 55.9403 107.78H52.8503ZM56.0782 97.4866H58.175C58.7635 97.4866 59.2693 97.2143 59.6923 96.6697C60.1338 96.1069 60.3545 95.3807 60.3545 94.4912C60.3545 93.7832 60.1614 93.2023 59.7751 92.7484C59.3889 92.2946 58.8555 92.0676 58.175 92.0676L56.0782 92.0949V97.4866Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2833 16.6688V12.5586H46.9475V16.6688L51.2986 16.6688L51.2986 20.3224L46.9475 20.3224V25.1177L51.2986 25.1177L51.2986 28.7712L46.9475 28.7712V33.5665L51.2986 33.5665L51.2986 37.22L46.9475 37.22V42.0153L51.2986 42.0153L51.2986 45.6688L46.9475 45.6688V50.4641H55.6497V60.0546C55.6497 65.8558 50.9333 70.5586 45.1154 70.5586C39.2974 70.5586 34.5811 65.8558 34.5811 60.0546V50.4641H43.2833V45.6688L38.9322 45.6688L38.9322 42.0153L43.2833 42.0153V37.22L38.9322 37.22L38.9322 33.5665L43.2833 33.5665V28.7712L38.9322 28.7712L38.9322 25.1176L43.2833 25.1177V20.3224L38.9322 20.3224L38.9322 16.6688L43.2833 16.6688ZM38.2452 54.1176V60.0546C38.2452 63.838 41.3211 66.905 45.1154 66.905C48.9097 66.905 51.9856 63.838 51.9856 60.0546V54.1176H38.2452ZM41.2223 58.6846L49.0085 58.6846L49.0085 62.3381L41.2223 62.3381L41.2223 58.6846Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.d5110f39010061dd255034cfa87a8872.svg";
export { ForwardRef as ReactComponent };